import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

class ConfiguracionInicial extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    /**
     * 
     * @param {any} productoSeleccionado
     * @param {any} cantidadEstados
     */
    btnComenzar(productoSeleccionado, cantidadEstados) {
        if (productoSeleccionado !== undefined && productoSeleccionado.Id != -1 && cantidadEstados > 0)
            this.props.inicioCreacion();
    }

    /**
     * 
     * @param {any} event
     */
    seleccionarCantidadEstados(event) {
        this.props.cambiarCombo(event.target.value, 'CANTIDADESTADO');
    }

    /**
     * 
     * @param {any} event
     */
    seleccionarProducto(event) {
        this.props.cambiarCombo(event.target.value, 'PRODUCTO');
    }

    render() {
        //Cargo el combos...
        let productosCircuitoResult = null;
        let estadosCircuitoResult = null;
        let estados = [{ Id: 0, Descripcion: 'Seleccione Cantidad' }, { Id: 1, Descripcion: '1' }, { Id: 2, Descripcion: '2' }, { Id: 3, Descripcion: '3' }, { Id: 4, Descripcion: '4' }, { Id: 5, Descripcion: '5' }, { Id: 6, Descripcion: '6' }, { Id: 7, Descripcion: '7' }, { Id: 8, Descripcion: '8' }, { Id: 9, Descripcion: '9' }];

        if (this.props.data.deliveryProductoTipo !== undefined) {
            productosCircuitoResult = this.props.data.deliveryProductoTipo.map((producto) => {
                return (
                    <GenericOption key={producto.Id} id={producto.Id} description={producto.Descripcion} />
                )
            })
        }

        estadosCircuitoResult = estados.map((producto) => {
            return (
                <GenericOption key={producto.Id} id={producto.Id} description={producto.Descripcion} />
            )
        })

        return (
            <div className="aside-left-circuito-estados">
                <div>
                    <label className="label-secondary">Seleccione producto</label>
                    <br />
                    <GenericSelect id="selectProductoCircuito" className="form-control default-select" options={productosCircuitoResult}
                        value={this.props.data.productoSeleccionado !== undefined ? this.props.data.productoSeleccionado.Id : 0} onChange={(e) => this.seleccionarProducto(e)} />
                </div>

                <div>
                    <label className="label-secondary">Cantidad de estados</label>
                    <br />
                    <GenericSelect id="selectEstadoCircuito" className="form-control default-select" options={estadosCircuitoResult}
                        value={this.props.data.cantidadEstados} onChange={(e) => this.seleccionarCantidadEstados(e)} />
                </div>

                <div className="button-circuito-estados">
                    <button id="btnComenzar" type="button" className="btn btn-secondary" onClick={() => this.btnComenzar(this.props.data.productoSeleccionado, this.props.data.cantidadEstados)}>
                        Iniciar creaci&#243;n
                        </button>
                </div>
            </div>
        );
    }
}

export default ConfiguracionInicial;
